import React, { Component } from 'react';
import Axios from 'axios';
import { API_URL } from '../API_url/API_URL';
import EventSeatIcon from '@material-ui/icons/EventSeat';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import { Button } from 'reactstrap';
import { addToCart } from '../redux/Action';
import { connect } from 'react-redux';

class Reservation extends Component {
    state = { 
        data: [],
        booked: [[0,0], [0,1]],
        chosen: [],
        price: 0,
        count: 0,
    };

    componentDidMount(){
        let { id } = this.props.location.state
        Axios.get(API_URL + `/movies/${id}`)
        .then((res) => {
            this.setState({booked: res.data.booked})
            // console.log(this.state.data)
        })
        .catch((err) => {
            console.log(err)
        })
    }

    onBtnSeatClick = (arr) => {
        let { chosen, price, count } = this.state;
            chosen.push(arr);
            this.setState({ 
                chosen,
                price: price + 50000,
                count: count + 1
            })
            console.log(chosen)
    }

    onBtnCancelSeat = (arr) => {
        let { chosen, price, count } = this.state;
        let output = chosen.filter((val) => {
            return val.join('') !== arr.join('')
        })
        this.setState({
            chosen: output,
            price: price - 50000,
            count: count -1
        })
    }
    
    addToCart = () => {
        console.log(this.props.cart)
        let { cart, idUser } = this.props
        let { name, id, booked} = this.props.location.state
        let { chosen, price, count } = this.state
        
        let addCart = {
            name,
            seats: chosen,
            totalPrice: price,
            ticketAmount: count
        }

        if(count === 0 || price === 0){
            return null
        }else{
            cart.push(addCart)
            booked.push(...chosen)
        }
        console.log(addCart)

        Axios.patch(API_URL + `/users/${idUser}`, {
            cart: cart
        })
        .then((res) => {
            console.log(res.data)
            Axios.patch(API_URL+`/movies/${id}`, {
                booked: booked
            }).then((res) => {
                console.log(res.data)
            })
        })
        .catch((err) => {
            console.log(err)
        })
    }

    renderSeat = () => {
        let seats = 100;
        let { chosen, booked } = this.state;
        let arr = [];

        for (let i = 0; i<seats/20; i++){
            arr.push([])
            for (let j = 0; j<seats/(seats/20); j++){
                arr[i].push(1)
            }
        }
         console.log(arr)
        for(let k = 0 ; k< booked.length; k++){
            arr[booked[k][0]][booked[k][1]] = 2
        }
        for(let l = 0 ; l< chosen.length; l++){
            arr[chosen[l][0]][chosen[l][1]] = 3
        }


        let alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
        return arr.map((val, index) => {
            return(
                <div className='d-flex justify-content-center '>
                    <th> {alphabet[index]+ ' '}</th>
                    {
                        val.map((val1,i) => {
                            if(val1 === 2){
                                return (
                                    <EventSeatIcon 
                                        color={"secondary"}
                                        disabled
                                        fontSize={"large"}
                                    />
                                )
                            }
                            if (val1 ===3){
                                return (
                                    <EventSeatIcon 
                                        color={"primary"}
                                        onClick={() => this.onBtnCancelSeat([index,i])}
                                        fontSize={"large"}
                                
                                    />
                                )
                            }
                            return(
                                <EventSeatIcon 
                                    onClick={() => this.onBtnSeatClick([index, i])} 
                                    fontSize={"large"} 
                                />
                            )
                        })
                    }
                    
                </div>
            )
        })
    }

    renderNum = (arr) => {
        let alpha = 'ABCDE'
        let arr2 = ''
        let out = []
        let output = []
        console.log(arr)
        for(var i =0; i<arr.length; i++){
            arr2 = parseInt(arr[i][1])+1
            out = (alpha[arr[i][0]] +arr2) + '; '
            output.push(out)
            
        }
        return output
    }



    render() { 
        // console.log(this.props.location.search)
        let { chosen } = this.state;

        var { name } = this.props.location.state
        return ( 
            <div className='container full-height'>
                <br/>
                <div className='d-flex justify-content-center'>
                    <h1>Choosing Seats for {name}</h1>
                </div>
                <div className='p-5'>
                {this.renderSeat()}
                <div className='mt-5 text-center'>screen</div>
                <div className='container border rounded p-1 ' style={{backgroundColor :'black',width:'50%'}}></div>
                </div>
                <br/>
                <div className='d-flex justify-content-center'>
                    <h5>
                        seat number: {this.renderNum(chosen)} | {this.state.count} seats 
                    </h5>
                </div>
                <div className='d-flex justify-content-center'>
                    <h5>
                        Total Rp. {this.state.price.toLocaleString()}
                    </h5>
                </div>
                    <div className='d-flex justify-content-center'> 
                    <Button color='primary' onClick={this.addToCart}>
                        <AddShoppingCartIcon />
                        Add to Cart
                    </Button>
                    </div>
            </div>
        );
    }
}

const mapStatetoProps = ({auth}) => {
    return {
        idUser: auth.id,
        cart: auth.cart
    }
}
 
export default connect(mapStatetoProps, {addToCart})(Reservation);